module.exports = __webpack_public_path__ + "img/closeButt.d7208966.svg";